import * as React from 'react';
import { Navigation } from 'utils/Navigation';

export class Link extends React.Component<LinkProps> {

    public constructor(props: LinkProps) {
        super(props);

        this.handleClick = this.handleClick.bind(this);
    }

    private handleClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
        if (this.props.forceReload) {
            return;
        }

        if (event.button != 0) {
            return;
        }

        if (event.ctrlKey) {
            return;
        }

        Navigation.pushState(null, this.props.href);
        event.preventDefault();
    }

    public render() {
        return (
            <a href={this.props.href} className={this.props.className} style={this.props.style} onClick={this.handleClick}>
                {this.props.children}
            </a>
        )
    }

}

export class LinkProps {

    public href: string;
    public className?: string;
    public style?: React.CSSProperties;
    public forceReload?: boolean;
    public children?: React.ReactNode;

}